<template>
    <div class="info-goods">
        <div class="info-text">
            <div class="info-title">{{goodsInfo.title}}</div>
            <div class="info-price">
                <span>¥</span>
                <span>{{goodsInfo.price}}</span>
            </div>
            <!-- <div class="info-num">
                <span>销量：{{goodsInfo.share}}</span>
                <span>库存：{{goodsInfo.inventory}}</span>
            </div> -->
        </div>
        <div class="info-share">
            <div class="share-count">
                <img class="share-img" src="@/assets/qrcode.png" alt="">
                <div class="share-title">二维码</div>
            </div>
            <div class="share-count">
                <img class="share-img" src="@/assets/share.png" alt="">
                <div class="share-title">分享</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // 商品基础信息
    name: 'VantInfo',
    props: {
        goodsInfo: {
            type: Object,
            default: () => {},
            reqeired: false
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    },
    mounted() {

    },
    watch: {

    },

}
</script>

<style lang="scss" scoped>
    .info-goods {
        padding: 16px;
        position: relative;
        background: #fff;
    }

    .info-title {
        width: 275px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        overflow: hidden;
    }

    .info-price {
        color: #D81333;
        margin-top: 3px;
    }

    .info-price span:nth-child(1) {
        font-size: 18px;
        margin-right: 2px;
    }

    .info-price span:nth-child(2) {
        font-size: 24px;
    }

    .info-num {
        color: #666666;
        margin-top: 5px;
        font-size: 12px;
    }

    .info-num span:nth-child(1) {
        margin-right: 20px;
    }

    .info-share {
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
    }

    .share-img {
        width: 20px;
        height: 20px;
    }

    .share-title {
        font-size: 10px;
        color: #666666;
        text-align: center;
    }

    .share-count {
        text-align: center;
    }

    .share-count:nth-child(1) {
        margin-right: 20px;
    }
</style>
